import { StrictMode } from "react";
import { createRoot } from "react-dom/client";
import { BrowserRouter } from "react-router";

import App from "./App.jsx";
import { ToastProvider } from "./components/ui.jsx";
import "./index.css";

/**
 * Installed, this should behave like an app rather than a page.
 *
 * Only when installed. iOS ignores `user-scalable=no` in a browser tab anyway,
 * and on the platforms that honour it, taking pinch-zoom away from someone
 * reading in a tab is taking away an accessibility control. In standalone mode
 * there is no address bar to zoom against and the gesture only ever misfires.
 */
const standalone = window.matchMedia("(display-mode: standalone)").matches || window.navigator.standalone === true;
if (standalone) {
    document
        .querySelector('meta[name="viewport"]')
        ?.setAttribute("content", "width=device-width, initial-scale=1, maximum-scale=1, user-scalable=no, viewport-fit=cover");
    document.documentElement.dataset.standalone = "true";
}

// Registered after load so it never competes with the first paint. Push is the
// reason it exists; on iOS it only works once the app is on the Home Screen.
if ("serviceWorker" in navigator) {
    window.addEventListener("load", () => {
        navigator.serviceWorker.register("/sw.js").catch(() => {});
    });
}

createRoot(document.getElementById("root")).render(
    <StrictMode>
        <BrowserRouter>
            <ToastProvider>
                <App />
            </ToastProvider>
        </BrowserRouter>
    </StrictMode>
);
